module.exports = __webpack_public_path__ + "img/views.d4327f6c.svg";